function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  opacity: 0.9
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.5845 19.7531C13.9554 19.7531 14.3263 19.614 14.6045 19.3358C16.5981 17.3422 19.1945 16.2759 21.9763 16.2759C24.7581 16.2759 27.4008 17.3422 29.3481 19.3358C29.9045 19.8922 30.8781 19.8922 31.4345 19.3358C31.9908 18.7795 31.9908 17.8522 31.4345 17.2495C28.9772 14.6995 25.5927 13.3086 22.0227 13.3086C18.4527 13.3086 15.0681 14.6995 12.5645 17.2495C12.0082 17.8059 12.0082 18.7331 12.5645 19.3358C12.8427 19.614 13.2136 19.7531 13.5845 19.7531Z",
  fill: "#C4C4C4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.459 21.1895C15.9027 21.7459 15.9027 22.6732 16.459 23.2759C16.7372 23.5541 17.1081 23.6932 17.479 23.6932C17.8499 23.6932 18.2208 23.5541 18.499 23.2759C20.3999 21.375 23.5063 21.375 25.4072 23.2759C25.9635 23.8322 26.8908 23.8322 27.4935 23.2759C28.0499 22.7195 28.0499 21.7922 27.4935 21.1895C24.5263 18.1295 19.519 18.1295 16.459 21.1895Z",
  fill: "#C4C4C4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.0227 28.9772C23.2774 28.9772 24.2945 27.9601 24.2945 26.7054C24.2945 25.4507 23.2774 24.4336 22.0227 24.4336C20.768 24.4336 19.7509 25.4507 19.7509 26.7054C19.7509 27.9601 20.768 28.9772 22.0227 28.9772Z",
  fill: "#C4C4C4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.7999 0H3.24544C1.43727 0 0 1.48363 0 3.24544V33.7526C0 35.5608 1.48363 36.9981 3.24544 36.9981H40.7535C42.5617 36.9981 43.9989 35.5144 43.9989 33.7526V3.24544C44.0453 1.43727 42.5617 0 40.7999 0ZM13.909 3.33817C14.6972 3.33817 15.2999 3.98726 15.2999 4.72907C15.2999 5.51725 14.6509 6.11998 13.909 6.11998C13.1209 6.11998 12.5181 5.47089 12.5181 4.72907C12.5181 3.9409 13.1209 3.33817 13.909 3.33817ZM9.6436 3.33817C10.4318 3.33817 11.0345 3.98726 11.0345 4.72907C11.0345 5.51725 10.3854 6.11998 9.6436 6.11998C8.85542 6.11998 8.2527 5.47089 8.2527 4.72907C8.2527 3.9409 8.90179 3.33817 9.6436 3.33817ZM5.37816 3.33817C6.16634 3.33817 6.76907 3.98726 6.76907 4.72907C6.76907 5.51725 6.11998 6.11998 5.37816 6.11998C4.58998 6.11998 3.98726 5.47089 3.98726 4.72907C3.98726 3.9409 4.63635 3.33817 5.37816 3.33817ZM39.8262 32.5472C39.8262 32.6863 39.7335 32.779 39.5944 32.779H4.45089C4.3118 32.779 4.21908 32.6863 4.21908 32.5472V9.50451H39.8262V32.5472Z",
  fill: "#C4C4C4"
}));

function SvgGroup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 37,
    viewBox: "0 0 44 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.cf73c484.svg";
export { ForwardRef as ReactComponent };